// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__19Ohq","large":"styles_large__2nbke"};